
import { createContext, useReducer } from "react";
import EntrepriseReducer from "./EntrepriseReducer";

const INITIAL_STATE = {
    entreprises: [],
    count: 1,
    isFetching: false,
    error: false,
    entreprise: {},
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    entreprisesMini: [],
    isFetchingActivate: false,
    errorActivate: false,
};


export const EntrepriseContext = createContext(INITIAL_STATE);

export const EntrepriseContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(EntrepriseReducer, INITIAL_STATE);
    
    return (
      <EntrepriseContext.Provider
        value={{
          entreprises: state.entreprises,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          entreprise: state.entreprise,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          entreprisesMini: state.entreprisesMini,
          isFetchingActivate: state.isFetchingActivate,
          errorActivate: state.errorActivate,
          dispatch,
        }}
      >
        {children}
      </EntrepriseContext.Provider>
    );
  };